<a
    class="resource-card pointer"
    [class.has-progress]="showProgress"
    (click)="open()"
    [style.background-color]="resource.color || null"
>
    <img
        src="/assets/images/Cloud%201.png"
        class="resource-card-clouds"
        alt=""
    />
    <div class="resource-card-type" [attr.data-type]="resource.type">
        {{ typeLabel }}
    </div>
    <div class="resource-card-category">{{ resource.categoryTitle || "" }}</div>
    <div class="resource-card-title">{{ resource.title }}</div>

    @if (showProgress) {
    <div class="resource-card-progress">
        @if (!isCompleted) {
        <div class="resource-card-progress-inner-wrapper">
            <img
                src="assets/icons/guide_proggress_wrapper.png"
                alt="progress icon"
            />
            <div class="resource-card-progress-value">
                {{ resource.progress }}
            </div>
            <div class="resource-card-progress-percentage">%</div>
        </div>
        } @if (isCompleted) {
        <div class="resource-card-progress-completed">
            <svg
                width="10"
                height="8"
                viewBox="0 0 10 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M4.22105 7.53487C3.61304 8.15638 2.63088 8.15638 2.02288 7.5268L0.315798 5.75911C-0.112922 5.31517 -0.105127 4.59679 0.339183 4.169C0.760108 3.74927 1.43047 3.76542 1.8358 4.18514L3.12196 5.51696L8.13409 0.326901C8.55501 -0.108967 9.23317 -0.108967 9.65409 0.326901L9.68527 0.359188C10.1062 0.795056 10.1062 1.50536 9.67748 1.94123L4.22105 7.53487Z"
                    fill="#2C2C2C"
                />
            </svg>
        </div>
        }
    </div>
    } @if (resource.image) {
    <img
        [src]="resource.image"
        class="resource-card-image"
        [class.progress_positioning]="
            resource.status === 'in_progress' || resource.status === 'completed'
        "
        [alt]="resource.title"
    />
    }
</a>
